import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VWidget',{attrs:{"enable-footer-actions":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('labels.success'))+" ")]},proxy:true},{key:"content",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('successMessage'))+" ")]},proxy:true}])},[_c('template',{slot:"footer-actions"},[_c(VBtn,{attrs:{"depressed":"","color":"primary"},on:{"click":_vm.onReset}},[_vm._v(" "+_vm._s(_vm.$t('labels.add'))+" ")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }